import { useTskContext } from '@Hooks/useTskContext.ts';
import { Navigate, Outlet } from 'react-router';
import { RoutePaths } from '@Util/misc.ts';
import { getContextId } from '@tlx/astro-shared';
import { PageLoading } from '@Component/Page/PageLoading.tsx';

export default function SalaryOnboardingProtectedRoute() {
    const { isShowSalaryOnboarding, isLoading } = useTskContext();
    const contextId = getContextId();
    if (isLoading) {
        return <PageLoading />;
    }
    if (isShowSalaryOnboarding) {
        return <Navigate to={RoutePaths.Onboarding + '?contextId=' + contextId} />;
    }

    return <Outlet />;
}
